module.exports = __webpack_public_path__ + "img/zhongbiao.9948142a.png";